/**
 * Angular library starter.
 * Build an Angular library compatible with AoT compilation & Tree shaking.
 * Written by Roberto Simonetti.
 * MIT license.
 * https://github.com/robisim74/angular-truncate-pipes
 */

/**
 * Entry point for all public APIs of the package.
 */
export {TruncatePipesModule} from './src/angular-truncate-pipes';
